export default __webpack_public_path__ + "static/media/red_circle.6c5d55e0.png";